<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.51,798.62l2.32-2.32l3.42,3.42l-1.33,1.33l1.46,1.46l4.12-4.12l-1.46-1.46l-1.33,1.33l-3.42-3.42l2.34-2.34l-2.34-2.34
	l3.41-3.42l1.33,1.33l1.46-1.46l-4.12-4.12l-1.46,1.46l1.33,1.34l-3.41,3.41l-2.33-2.33l-2.33,2.33l-3.42-3.42l1.33-1.33l-1.46-1.46
	l-4.12,4.12l1.46,1.46l1.33-1.33l3.42,3.42l-2.33,2.33l2.33,2.33l-3.42,3.42l-1.33-1.33l-1.46,1.46l4.12,4.12l1.46-1.46l-1.33-1.34
	l3.42-3.42L0.51,798.62z M0.51,788.32l4.18,4.18l-4.18,4.18l-4.18-4.18L0.51,788.32z"/>
</svg>

</template>